import { styled } from 'linaria/react';
import { COLORS } from 'styles/constants';

export const StyledWrap = styled.button<{ isToolTipShown: boolean; isDark: boolean }>`
  background: transparent;
  align-items: center;
  border: none;
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 0;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    circle {
      fill: ${({ isToolTipShown, isDark }) => {
        if (isToolTipShown) {
          return COLORS.brown.dark[100];
        }

        return isDark ? COLORS.white[100] : COLORS.brown.dark[100];
      }};
    }
    path {
      stroke: ${({ isToolTipShown, isDark }) => {
        if (isToolTipShown) {
          return COLORS.brown.dark[100];
        }

        return isDark ? COLORS.white[100] : COLORS.brown.dark[100];
      }};
    }
  }
`;

export const StyledRelWrap = styled.div`
  position: relative;
  z-index: 10;
  border-radius: 50%;
`;
